import React from 'react'
import { Button } from './Button'
import { cn } from './cn'

export function Pagination({ pagination, onPrev, onNext, className }) {
  if (!pagination) return null
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-2 text-sm text-text-muted dark:text-text-muted-dark', className)}>
      <span>
        {pagination.totalItems} result{pagination.totalItems === 1 ? '' : 's'}
      </span>
      <div className="flex items-center gap-2">
        <Button type="button" variant="secondary" size="sm" onClick={onPrev} disabled={!pagination.hasPrevPage}>
          Previous
        </Button>
        <span className="text-secondary-700 dark:text-secondary-300">
          Page {pagination.currentPage} of {pagination.totalPages}
        </span>
        <Button type="button" variant="secondary" size="sm" onClick={onNext} disabled={!pagination.hasNextPage}>
          Next
        </Button>
      </div>
    </div>
  )
}
